module.exports = __webpack_public_path__ + "static/media/ventos.10e5ad88.mp4";